// @constants
const {
    CREDIT,
    E_CARD,
    HORMIGUERO_CARD,
    MAESTRO_CARD,
    METALLIC_CARD,
    NERUDA_CARD,
    OPEN_DEBIT_CARD,
    OPEN_YOUNG_PACK,
    OPEN_YOUNG,
    SOLIDARITY_CARD_CONTRACT,
    VANITY_CARD,
    VIRTUAL_DEBIT_CANCER_CARDART,
    VIRTUAL_DEBIT_PRIDE_CARDART,
    VIRTUAL_CREDIT_CARD,
    NOT_ALLOWED_NEW_COMPLETE_CREDIT_CARDS_FLOW_COUNTRIES
} = require('constants/flagBasedFeatures');
const { OPEN_YOUNG_PACK_KEY, ENGLISH_LANGUAGE } = require('constants/index.js');
const { getLanguage } = require('core/i18n').i18n;

const getVirtualDebitSidebarImgId = (immFlagBasedFeatures) => {
    let virtualDebitSidebarImgId = 'B.506.012.001';

    if (immFlagBasedFeatures.get(VIRTUAL_DEBIT_CANCER_CARDART)) {
        virtualDebitSidebarImgId = 'B.506.012.004';
    } else if (immFlagBasedFeatures.get(VIRTUAL_DEBIT_PRIDE_CARDART)) {
        virtualDebitSidebarImgId = 'B.506.012.003';
    }

    return virtualDebitSidebarImgId;
}

const getCardsProductBanners = (immFlagBasedFeatures) => {
    const isEnglishLanguage = getLanguage() === ENGLISH_LANGUAGE

    return {
        '506011': {
            id: 'charity',
            featureTogglingKey: SOLIDARITY_CARD_CONTRACT,
            title: 'banner506011-title',
            sidebarImgAlt: "banner506011-title",
            sidebarImgId: "B.506.011.001",
            sidebarImgUrl: 'https://www.openbank.es/assets/static/private-assets/images/commercial-banners/tarjeta_solidaria.jpg',
            subtitle: 'banner506011-subtitle',
            advantages: [
                {
                    text: 'banner506011-advantage01',
                    icon: 'icon-tarjeta-solidaria'
                },
                {
                    text: 'banner506011-advantage02',
                    icon: 'icon-0-euro'
                },
                {
                    text: 'banner506011-advantage03',
                    icon: 'icon-depositos'
                },
                {
                    text: 'banner506011-advantage04',
                    icon: 'icon-cajero'
                }
            ],
            link: '/myprofile/hire/card/solidarity'
        },
        '506002': {
            id: 'open_debit', //this is used to identify tag new
            featureTogglingKey: OPEN_DEBIT_CARD,
            title: 'banner506002-title',
            sidebarImgAlt: "banner506002-title",
            sidebarImgId: "B.506.002.020",
            sidebarImgIdByCountry: {
                "es": "B.506.002.020",
                "de": "B.506.013.012",
                "nl": "B.506.014.017",
                "pt": "B.506.015.012"
            },
            sidebarImgIdByCountryStandardOff: {
                "de": "B.506.013.007",
                "nl": "B.506.014.017",
                "pt": "B.506.015.007"
            },
            sidebarImgUrl: 'https://www.openbank.es/assets/static/private-assets/images/commercial-banners/tarjeta_open_debit.jpg',
            subtitle: 'banner506002-subtitle',
            advantages: [
                {
                    text: 'banner506002-advantage01',
                    icon: 'icon-0-euro',
                    iconByCountry: {
                        "es": "icon-0-euro",
                        "de": "icon-0-euro",
                        "nl": "icon-colectivos",
                        "pt": "icon-0-euro"
                    }
                },
                {
                    text: 'banner506002-advantage02',
                    icon: 'icon-cajero'
                },
                {
                    text: 'banner506002-advantage03',
                    icon: 'icon-compras-seguras'
                },
                {
                    text: 'banner506002-advantage04',
                    icon: 'icon-seguro-accidentes',
                    iconByCountry: {
                        "es": "icon-seguro-accidentes",
                        "de": "icon-global",
                        "nl": "icon-viaje-hoteles",
                        "pt": "icon-global"
                    }
                }
            ],
            link: '/myprofile/hire/card/open-debit'
        },
        '500801': {
            id: 'open_credit',
            featureTogglingKey: CREDIT,
            title: 'banner500801-title',
            sidebarImgAlt: "banner500801-title",
            sidebarImgId: "B.500.801.012",
            sidebarImgUrl: 'https://www.openbank.es/assets/static/private-assets/images/commercial-banners/tarjeta_open_credit.jpg',
            subtitle: 'banner500801-subtitle',
            advantages: [
                {
                    text: 'banner500801-advantage01',
                    icon: 'icon-0-euro'
                },
                {
                    text: 'banner500801-advantage02',
                    icon: 'icon-flexibilidad'
                },
                {
                    text: 'banner500801-advantage03',
                    icon: 'icon-compras-seguras'
                },
                {
                    text: 'banner500801-advantage04',
                    icon: 'icon-seguro-accidentes'
                }
            ],
            link: !__CONTACT_CENTER__ && immFlagBasedFeatures.get(NOT_ALLOWED_NEW_COMPLETE_CREDIT_CARDS_FLOW_COUNTRIES) ?
                isEnglishLanguage ? '/credit-card-visa-opencredit' : '/tarjeta-credito-visa-open-credit'
                : '/myprofile/hire/card/open-credit'
        },
        '500003': {
            id: 'revolving',
            featureTogglingKey: CREDIT,
            title: 'banner500003-title',
            sidebarImgAlt: "banner500003-title",
            sidebarImgId: "B.500.003.001",
            sidebarImgUrl: 'https://www.openbank.es/assets/static/private-assets/images/commercial-banners/tarjeta_revolving.jpg',
            subtitle: 'banner500003-subtitle',
            advantages: [
                {
                    text: 'banner500003-advantage01',
                    icon: 'icon-0-euro'
                },
                {
                    text: 'banner500003-advantage02',
                    icon: 'icon-flexibilidad'
                },
                {
                    text: 'banner500003-advantage03',
                    icon: 'icon-compras-seguras'
                },
                {
                    text: 'banner500003-advantage04',
                    icon: 'icon-seguro-accidentes'
                }
            ],
            link: '/myprofile/hire/card/revolving'
        },
        '500803': {
            id: 'virtualcredit',
            featureTogglingKey: VIRTUAL_CREDIT_CARD,
            title: 'bannerVirtualCredit-bannerVirtualCredit_title',
            sidebarImgAlt: "bannerVirtualCredit-bannerVirtualCredit_title",
            sidebarImgId: "B.500.803.001",
            sidebarImgUrl: 'https://www.openbank.es/assets/static/private-assets/images/commercial-banners/virtual_credit.jpg',
            subtitle: 'bannerVirtualCredit-bannerVirtualCredit_subtitle',
            advantages: [
                {
                    text: 'bannerVirtualCredit-bannerVirtualCredit_advantage01',
                    icon: 'icon-movil'
                },
                {
                    text: 'bannerVirtualCredit-bannerVirtualCredit_advantage02',
                    icon: 'icon-0-euro'
                },
                {
                    text: 'bannerVirtualCredit-bannerVirtualCredit_advantage03',
                    icon: 'icon-compras-seguras'
                },
                {
                    text: 'bannerVirtualCredit-bannerVirtualCredit_advantage04',
                    icon: 'icon-seguro-accidentes'
                }
            ],
            link: !__CONTACT_CENTER__ && immFlagBasedFeatures.get(NOT_ALLOWED_NEW_COMPLETE_CREDIT_CARDS_FLOW_COUNTRIES) ?
                isEnglishLanguage ? '/virtual-credit-card' : '/tarjeta-credito-virtual'
                : '/myprofile/hire/card/virtual-credit'
        },
        '532001': {
            id: 'via_t',
            featureTogglingKey: CREDIT,
            title: 'banner532001-title',
            sidebarImgAlt: "banner532001-title",
            sidebarImgId: "B.532.001.001",
            sidebarImgUrl: 'https://www.openbank.es/assets/static/private-assets/images/commercial-banners/tarjeta_viat.jpg',
            subtitle: 'banner532001-subtitle',
            advantages: [
                {
                    text: 'banner532001-advantage01',
                    icon: 'icon-tiempo'
                },
                {
                    text: 'banner532001-advantage02',
                    icon: 'icon-global'
                },
                {
                    text: 'banner532001-advantage03',
                    icon: 'icon-candado'
                },
                {
                    text: 'banner532001-advantage04',
                    icon: 'icon-descuento'
                }
            ],
            link: !__CONTACT_CENTER__ && immFlagBasedFeatures.get(NOT_ALLOWED_NEW_COMPLETE_CREDIT_CARDS_FLOW_COUNTRIES) ?
                isEnglishLanguage ? '/via-t-card' : '/tarjeta-via-t-credito'
                : '/myprofile/hire/card/via-t'
        },
        '506003': {
            id: 'ecard',
            featureTogglingKey: E_CARD,
            title: 'banner506003-title',
            sidebarImgAlt: "banner506003-title",
            sidebarImgId: "B.506.003.002",
            sidebarImgIdByCountry: {
                "es": "B.506.003.002",
                "de": "B.506.016.001",
                "nl": "B.506.017.001",
                "pt": "B.506.018.001"
            },
            sidebarImgUrl: 'https://www.openbank.es/assets/static/private-assets/images/commercial-banners/tarjeta_ecard.jpg',
            subtitle: 'banner506003-subtitle',
            advantages: [
                {
                    text: 'banner506003-advantage01',
                    icon: 'icon-movil'
                },
                {
                    text: 'banner506003-advantage02',
                    icon: 'icon-0-euro'
                },
                {
                    text: 'banner506003-advantage03',
                    icon: 'icon-candado',
                    iconByCountry: {
                        "es": "icon-candado",
                        "de": "icon-compras-seguras",
                        "nl": "icon-compras-seguras",
                        "pt": "icon-compras-seguras"
                    }
                },
                {
                    text: 'banner506003-advantage04',
                    icon: 'icon-seguro-accidentes',
                    iconByCountry: {
                        "es": "icon-seguro-accidentes",
                        "de": "icon-global",
                        "nl": "icon-global",
                        "pt": "icon-global"
                    }
                }
            ],
            link: '/myprofile/hire/card/e-card'
        },
        '506010': {
            id: 'open_young',
            featureTogglingKey: OPEN_YOUNG,
            title: 'banner506010-title',
            sidebarImgAlt: "banner506010-title",
            sidebarImgId: "B.506.010.001",
            sidebarImgUrl: 'https://www.openbank.es/assets/static/private-assets/images/commercial-banners/tarjeta_openyoung.jpg',
            subtitle: 'banner506010-subtitle',
            advantages: [
                {
                    text: 'banner506010-advantage01',
                    icon: 'icon-tarjetas'
                },
                {
                    text: 'banner506010-advantage02',
                    icon: 'icon-movil'
                },
                {
                    text: 'banner506010-advantage03',
                    icon: 'icon-candado'
                },
                {
                    text: 'banner506010-advantage04',
                    icon: 'icon-0-euro'
                }
            ],
            link: '/myprofile/hire/card/open-young'
        },
        'premiumPack': {
            id: 'pack_premium',
            featureTogglingKey: CREDIT,
            title: 'bannerPremiumPack-title',
            sidebarImgAlt: "bannerPremiumPack-title",
            sidebarImgId: "B.501.003.003",
            sidebarImgUrl: 'https://www.openbank.es/assets/static/private-assets/images/commercial-banners/tarjeta_premium.jpg',
            sidebarExtraImgId: "B.506.009.003",
            subtitle: 'bannerPremiumPack-subtitle',
            advantages: [
                {
                    text: 'bannerPremiumPack-advantage01',
                    icon: 'icon-cajero'
                },
                {
                    text: 'bannerPremiumPack-advantage02',
                    icon: 'icon-beneficios-monetarios'
                },
                {
                    text: 'bannerPremiumPack-advantage03',
                    icon: 'icon-compras-seguras'
                },
                {
                    text: 'bannerPremiumPack-advantage04',
                    icon: 'icon-seguro-accidentes'
                }
            ],
            link: !__CONTACT_CENTER__ && immFlagBasedFeatures.get(NOT_ALLOWED_NEW_COMPLETE_CREDIT_CARDS_FLOW_COUNTRIES) ?
                isEnglishLanguage ? '/pack-premium-card' : '/pack-tarjeta-premium'
                : '/myprofile/purchase/premium-pack'
        },
        'diamondPack': {
            id: 'pack_diamond',
            featureTogglingKey: CREDIT,
            title: 'bannerDiamondPack-title',
            sidebarImgAlt: "bannerDiamondPack-title",
            sidebarImgId: "B.501.002.003",
            sidebarImgUrl: 'https://www.openbank.es/assets/static/private-assets/images/commercial-banners/tarjeta_diamond.jpg',
            sidebarExtraImgId: "B.506.008.003",
            subtitle: 'bannerDiamondPack-subtitle',
            advantages: [
                {
                    text: 'bannerDiamondPack-advantage01',
                    icon: 'icon-cajero'
                },
                {
                    text: 'bannerDiamondPack-advantage02',
                    icon: 'icon-beneficios-monetarios'
                },
                {
                    text: 'bannerDiamondPack-advantage03',
                    icon: 'icon-especialista'
                },
                {
                    text: 'bannerDiamondPack-advantage04',
                    icon: 'icon-candado'
                }
            ],
            link: !__CONTACT_CENTER__ && immFlagBasedFeatures.get(NOT_ALLOWED_NEW_COMPLETE_CREDIT_CARDS_FLOW_COUNTRIES) ?
                isEnglishLanguage ? '/pack-diamond-card' : '/pack-tarjeta-diamond'
                : '/myprofile/hire/card/diamond-pack'
        },
        '506005': {
            id: 'at_home_abroad',
            featureTogglingKey: CREDIT,
            title: 'banner506005-title',
            sidebarImgAlt: "banner506005-title",
            sidebarImgId: "B.506.005.001",
            sidebarImgUrl: 'https://www.openbank.es/assets/static/private-assets/images/commercial-banners/tarjeta_at_home_abroad.jpg',
            subtitle: 'banner506005-subtitle',
            advantages: [
                {
                    text: 'banner506005-advantage01',
                    icon: 'icon-0-euro'
                },
                {
                    text: 'banner506005-advantage02',
                    icon: 'icon-cajero'
                },
                {
                    text: 'banner506005-advantage03',
                    icon: 'icon-compras-seguras'
                },
                {
                    text: 'banner506005-advantage04',
                    icon: 'icon-seguro-accidentes'
                }
            ],
            link: '/myprofile/hire/card/at-home-abroad'
        },
        [OPEN_YOUNG_PACK_KEY]: {
            id: 'pack_open_young',
            featureTogglingKey: OPEN_YOUNG_PACK,
            title: 'bannerOpenYoungPack-bannerOpenYoungPack_cardTitle',
            sidebarImgAlt: 'bannerOpenYoungPack-bannerOpenYoungPack_cardTitle',
            sidebarImgId: 'B.506.010.001',
            sidebarImgUrl: 'https://www.openbank.es/assets/static/private-assets/images/commercial-banners/pack_openyoung.jpg',
            subtitle: 'bannerOpenYoungPack-bannerOpenYoungPack_cardSubtitle',
            advantages: [
                {
                    text: 'bannerOpenYoungPack-bannerOpenYoungPack_cardAdvantage01',
                    icon: 'icon-porcentaje'
                },
                {
                    text: 'bannerOpenYoungPack-bannerOpenYoungPack_cardAdvantage02',
                    icon: 'icon-ahorra-dinero'
                },
                {
                    text: 'bannerOpenYoungPack-bannerOpenYoungPack_cardAdvantage03',
                    icon: 'icon-candado'
                },
                {
                    text: 'bannerOpenYoungPack-bannerOpenYoungPack_cardAdvantage04',
                    icon: 'icon-0-euro'
                }
            ],
            link: '/myprofile/hire/pack/open-young'
        },
        '506012': {
            id: 'virtualOnlyDebit',
            featureTogglingKey: OPEN_YOUNG,
            title: 'bannerVirtualOnlyDebit-title', //506012
            sidebarImgAlt: "banner506012-title",
            sidebarImgId: getVirtualDebitSidebarImgId(immFlagBasedFeatures),
            sidebarImgUrl: 'https://www.openbank.es/assets/static/private-assets/images/commercial-banners/virtual_credit.jpg',
            subtitle: 'banner506012-subtitle',
            advantages: [
                {
                    text: 'banner506012-advantage01',
                    icon: 'icon-0-euro'
                },
                {
                    text: 'banner506012-advantage02',
                    icon: 'icon-movil'
                },
                {
                    text: 'banner506012-advantage03',
                    icon: 'icon-candado'
                },
                {
                    text: 'banner506012-advantage04',
                    icon: 'icon-seguro-accidentes'
                }
            ],
            link: '/myprofile/hire/card/virtual-only-debit'
        },
        'maestro': {
            id: 'maestro_card',
            featureTogglingKey: MAESTRO_CARD,
            title: 'bannerMaestro-title',
            sidebarImgAlt: "bannerMaestro-title",
            sidebarImgId: "B.506.019.007",
            sidebarImgIdByCountry: {
                "nl": "B.506.019.012"
            },
            sidebarImgIdByCountryStandardOff: {
                "nl": "B.506.019.007"
            },
            sidebarImgUrl: 'https://www.openbank.es/assets/static/private-assets/images/commercial-banners/tarjeta_maestro.jpg',
            subtitle: 'bannerMaestro-subtitle',
            advantages: [
                {
                    text: 'bannerMaestro-advantage01',
                    icon: 'icon-0-euro'
                },
                {
                    text: 'bannerMaestro-advantage02',
                    icon: 'icon-cajero'
                },
                {
                    text: 'bannerMaestro-advantage03',
                    icon: 'icon-compras-seguras'
                },
                {
                    text: 'bannerMaestro-advantage04',
                    icon: 'icon-seguro-accidentes'
                }
            ],
            link: '/myprofile/hire/card/maestro'
        },
        'metallic': {
            id: 'metallic',
            featureTogglingKey: METALLIC_CARD,
            title: 'bannerMetallic-title',
            sidebarImgAlt: "bannerMetallic-title",
            sidebarImgId: "B.506.020.001",
            sidebarImgIdByCountry: {
                "de": "B.506.020.001",
                "nl": "B.506.021.001",
                "pt": "B.506.022.001"
            },
            sidebarImgUrl: 'https://www.openbank.es/assets/static/private-assets/images/commercial-banners/tarjeta_metalica.jpg',
            sidebarImgUrlByCountry: {
                "de": 'https://www.openbank.de/assets/static/private-assets/images/commercial-banners/tarjeta_metalica.jpg',
                "nl": 'https://www.openbank.nl/assets/static/private-assets/images/commercial-banners/tarjeta_metalica.jpg',
                "es": 'https://www.openbank.es/assets/static/private-assets/images/commercial-banners/tarjeta_metalica.jpg',
                "pt": 'https://www.openbank.pt/assets/static/private-assets/images/commercial-banners/tarjeta_metalica.jpg'
            },
            subtitle: 'bannerMetallic-subtitle',
            advantages: [
                {
                    text: 'bannerMetallic-advantage01',
                    icon: 'icon-tarjetas'
                },
                {
                    text: 'bannerMetallic-advantage02',
                    icon: 'icon-especialista'
                },
                {
                    text: 'bannerMetallic-advantage03',
                    icon: 'icon-global'
                },
                {
                    text: 'bannerMetallic-advantage04',
                    icon: 'icon-cajero'
                }
            ],
            link: '/myprofile/hire/card/metallic'
        },
        '500805': {
            id: 'vanity',
            featureTogglingKey: VANITY_CARD,
            title: 'bannerVanity-title',
            sidebarImgAlt: "bannerVanity-title",
            sidebarImgId: "B.500.805.001",
            sidebarImgUrl: 'https://www.openbank.es/assets/static/private-assets/images/commercial-banners/Tarjeta_VF.jpg',
            subtitle: 'bannerVanity-subtitle',
            advantages: [
                {
                    text: 'bannerVanity-advantage01',
                    icon: 'icon-transparencia'
                },
                {
                    text: 'bannerVanity-advantage02',
                    icon: 'icon-tarjetas'
                },
                {
                    text: 'bannerVanity-advantage03',
                    icon: 'icon-formacion-profesional'
                },
                {
                    text: 'bannerVanity-advantage04',
                    icon: 'icon-regalo'
                }
            ],
            link: !__CONTACT_CENTER__ && immFlagBasedFeatures.get(NOT_ALLOWED_NEW_COMPLETE_CREDIT_CARDS_FLOW_COUNTRIES) ?
                isEnglishLanguage ? '/reading-club-card-vanity-fair' : '/tarjeta-club-lectura-vanity-fair'
                : '/myprofile/hire/card/vanity-fair'
        },
        '500802': {
            id: 'neruda',
            featureTogglingKey: NERUDA_CARD,
            title: 'bannerNeruda-title',
            sidebarImgAlt: 'bannerNeruda-title',
            sidebarImgId: 'B.500.802.014',
            sidebarImgUrl: 'https://www.openbank.es/assets/static/private-assets/images/commercial-banners/Tarjeta_R42_Viajera.jpg',
            subtitle: 'bannerNeruda-subtitle',
            advantages: [
                {
                    text: 'bannerNeruda-advantage01',
                    icon: 'icon-formacion-profesional'
                },
                {
                    text: 'bannerNeruda-advantage02',
                    icon: 'icon-cajero'
                },
                {
                    text: 'bannerNeruda-advantage03',
                    icon: 'icon-candado'
                },
                {
                    text: 'bannerNeruda-advantage04',
                    icon: 'icon-seguro-accidentes'
                }
            ],
            link: !__CONTACT_CENTER__ && immFlagBasedFeatures.get(NOT_ALLOWED_NEW_COMPLETE_CREDIT_CARDS_FLOW_COUNTRIES) ?
                isEnglishLanguage ? '/credit-card-without-switching-banks' : '/tarjeta-credito-sin-cambiar-de-banco'
                : '/myprofile/hire/card/nrd-card'

        },
        '500804': {
            id: 'hormiguero',
            featureTogglingKey: HORMIGUERO_CARD,
            title: 'bannerHormiguero-title',
            sidebarImgAlt: "bannerHormiguero-title",
            sidebarImgId: "B.500.804.001",
            sidebarImgUrl: 'https://www.openbank.es/assets/static/private-assets/images/commercial-banners/Tarjeta_EH.jpg',
            subtitle: 'bannerHormiguero-subtitle',
            advantages: [
                {
                    text: 'bannerHormiguero-advantage01',
                    icon: 'icon-formacion-profesional'
                },
                {
                    text: 'bannerHormiguero-advantage02',
                    icon: 'icon-cajero'
                },
                {
                    text: 'bannerHormiguero-advantage03',
                    icon: 'icon-seguro-accidentes'
                },
                {
                    text: 'bannerHormiguero-advantage04',
                    icon: 'icon-regalo'
                }
            ],
            link: '/myprofile/hire/card/eh-card'
        },
    };
};

module.exports = getCardsProductBanners;
